import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoHeartbeat = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Heartbeat</title>
    <path
      d="M3.998 20.797H7.73l1.412-3.804 3.428 5.143 2.286-9.714 2.017 8.375h3.697"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.268 23.395c.877.936 5.805 4.761 5.805 4.761.514.369 1.333.352 1.835-.027 0 0 4.966-3.825 5.823-4.735 1.402-1.488 5.652-5.039 5.835-9.317.162-3.812-3.215-7.369-7.181-7.369-1.538 0-2.76.358-4.132 1.35C16.712 8.45 16 9.22 16 9.22s-.79-.822-1.254-1.16c-1.369-.997-2.593-1.35-4.132-1.35-3.965 0-7.344 3.556-7.18 7.368.044 1.025.338 2.027.776 2.973"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);
export default SvgIcoHeartbeat;
